import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"flex-end","margin-bottom":"12px"} }
const _hoisted_2 = { class: "form-title mb-10 mt-30" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "underlineForm" }
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_MiniBusinessList = _resolveComponent("MiniBusinessList")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.chargeVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.chargeVisible) = $event)),
    title: _ctx.isRefundMode ? '登记客户退款' : '登记客户收款',
    width: "80%",
    onClose: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          onClick: _ctx.handleCancel,
          type: "danger"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleCharge
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("确定", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.isRefundMode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isRefundMode) = $event)),
          size: "default",
          onChange: _ctx.handleModeChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { value: false }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("登记收款", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { value: true }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("登记退款", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "form-title mb-10" }, [
        _createElementVNode("span", { class: "label blue" }, "业"),
        _createElementVNode("span", { class: "left" }, "业务信息")
      ], -1)),
      _createVNode(_component_MiniBusinessList, {
        businessList: _ctx.chargeDetail,
        ref: "miniBusinessList"
      }, {
        before: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "no",
            label: "编号",
            "show-overflow-tooltip": "",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "名称",
            "show-overflow-tooltip": "",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "brand",
            label: "品牌",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "received",
            label: "已收费用",
            "show-overflow-tooltip": "",
            align: "right",
            "min-width": "100"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.$currency(row.received)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "receivedAmount",
            label: _ctx.isRefundMode ? '退款金额' : '收款金额',
            "show-overflow-tooltip": "",
            align: "right",
            "min-width": "140"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_input_number, {
                modelValue: row.receivedAmount,
                "onUpdate:modelValue": ($event: any) => ((row.receivedAmount) = $event),
                type: "number",
                min: 0,
                max: _ctx.isRefundMode ? Number(row.received) : undefined,
                onInput: ($event: any) => (_ctx.handleFeeInput(row)),
                precision: 2
              }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onInput"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "remainAmount",
            label: _ctx.isRefundMode ? '退款后待收费用' : '待收费用',
            "show-overflow-tooltip": "",
            align: "right",
            width: "130"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.$currency(row.remainAmount)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        after: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "businessAmount",
            label: "数量",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoiceStatus",
            label: "开票状态",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "receivedStatus",
            label: "收款状态",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "salesMan",
            label: "业务代表",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "customerCompany",
            label: "客户公司",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "ticketCompany",
            label: "所属公司",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "type",
            label: "维修类型",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "unit",
            label: "单位",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            prop: "model",
            label: "型号",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "serial",
            label: "序列号",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["businessList"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(["label", _ctx.isRefundMode ? 'yellow' : 'green'])
        }, _toDisplayString(_ctx.isRefundMode ? '退' : '费'), 3),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.isRefundMode ? '退款信息' : '收费信息'), 1)
      ]),
      _createVNode(_component_el_form, {
        ref: "dataForm",
        model: _ctx.chargeForm,
        rules: _ctx.rules,
        "label-position": "top",
        "label-width": "100px",
        class: "mb-20"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form_item, {
              label: _ctx.isRefundMode ? '退款账户' : '公司账户',
              prop: "accountId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.chargeForm.accountId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chargeForm.accountId) = $event)),
                  class: "filter-item",
                  placeholder: "输入关键字搜索",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.isRefundMode ? '退款时间' : '到账时间',
              prop: "date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.chargeForm.date,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chargeForm.date) = $event)),
                  type: "date",
                  placeholder: "请选择日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "size"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.isRefundMode ? '退款原因/备注' : '收款备注',
              prop: "paymentMark",
              class: "fullWidth"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeForm.paymentMark,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.chargeForm.paymentMark) = $event)),
                  placeholder: _ctx.isRefundMode ? '请输入退款原因及备注说明' : '请输入收款备注',
                  type: "textarea"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]))
}